// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MClo7","fullView":"styles_fullView__2IL05"};